// Makes Object.keys() type-safe
export const getObjectKeys = <T extends object>(object: T) =>
  Object.keys(object) as Array<keyof T>
